import '../css/style.css'
import '../css/mobile-style.css'
import { Map, View } from 'ol'
import ZoomToExtent from 'ol/control/ZoomToExtent.js';
import Bar from 'ol-ext/control/Bar';
import { layers, itineraryEntriesData, travelsData, baseLayers, chronologicalData, sortedData, itineraryEntries, generateSortedData, itineraryPlacesData } from './source'
import ScaleLine from 'ol/control/ScaleLine'
import { unByKey } from 'ol/Observable'
import { createConditions, selectPeriod, selectPeriodTravels, } from './periodFilter'
import { selectfeature, popup } from './popupFeature'
import { select, search } from './search'
import LayerSwitcherImage from 'ol-ext/control/LayerSwitcherImage'
import { filterPlaces, filterTravels } from './filter'
import { permalinkFeature, applyOnStartDateFilter, setDate, triggerDateChange, DEFAULT_START, DEFAULT_END } from './datepicker'
import { legendCtrl } from './legend'
import { filterChronological } from './chronologicalFilter'
import { saveAs } from 'file-saver';
import Print from 'ol-ext/control/Print';




// default zoom, center and rotation
let zoom = 4.8;
let center = [1536000, 5558000];
let rotation = 0;


const map = new Map({
  target: 'map',
  layers: layers,
  view: new View({
    center: center,
    zoom: zoom,
    rotation: rotation,
    minZoom: 4.8,
    extent: [-3776000, 2545000, 6993000, 8151000]
  })
});

/////////--------------------------------------------Toolbox bar----------------------------------------------------------

// Main control bar
var mainbar = new Bar();
map.addControl(mainbar);
mainbar.setPosition('right');

mainbar.addControl(map.getControls().array_[0])

//mainbar.addControl(new Zoom());
mainbar.addControl(new ZoomToExtent({
  extent: [-3776000, 2545000, 6993000, 8151000],
  label: '',
  tipLabel: 'Zoom to extent',

}));


map.addControl(permalinkFeature);

map.once('rendercomplete', function (event) {
  applyOnStartDateFilter();
});



map.addControl(new LayerSwitcherImage({
  collapsed: false,
  layerGroup: baseLayers,
}));

// Scale control
map.addControl(new ScaleLine());

//----------------------------PopupFeature-----------------------------

map.addInteraction(selectfeature);
map.addOverlay(popup);
$(document).on('click', '#datapanel, #aboutProject', function () {
  popup.hide();
});
popup.on('hide', function () { selectfeature.getFeatures().clear() })



popup.on('show', (e) => {


  $('.ol-popup').find('.ol-popupfeature').append(
    '<div class="btn-group-vertical idi-switch" role="group" aria-label="Vertical button group">' +
    '<button type="button" class="btn btn-primary idi-up" style="height: 1.05em;"><i class="bi bi-caret-up-fill switch-caret"></i></button>' +
    '<button type="button" class="btn btn-primary idi-down" style="height: 1.05em;"><i class="bi bi-caret-down-fill switch-caret"></i></button>' +
    '</div>')

  var idi = parseInt(e.target._features[e.target._count - 1].values_.IDI_No)

  $('.idi-up').on('click', function () {

    var next = sortedData[sortedData.findIndex(p => p.IDI == idi) + 1].IDI

    popup.hide()
    selectfeature.getFeatures().clear()
    itineraryEntriesData.forEachFeature(function (feature) {

      if (feature.getProperties().IDI_No == next) {
        selectfeature.getFeatures().push(feature)
        popup.show(feature)
        var p = feature.getGeometry().getFirstCoordinate();
        map.getView().animate({
          center: p,
        });
      }



    })


  });
  $('.idi-down').on('click', function () {
    var prev = sortedData[sortedData.findIndex(p => p.IDI == idi) - 1].IDI
    popup.hide()
    selectfeature.getFeatures().clear()
    itineraryEntriesData.forEachFeature(function (feature) {

      if (feature.getProperties().IDI_No == prev) {
        selectfeature.getFeatures().push(feature)
        popup.show(feature)
        var p = feature.getGeometry().getFirstCoordinate();
        map.getView().animate({
          center: p,
        });
      }
    })
  });
})

//-----------------------------Search Places---------------------------

//Search in miejscowosci layer

map.addControl(search);

// Select feature when click on the reference index
search.on('select', function (e) {

  select.getFeatures().clear();
  select.getFeatures().push(e.search);
  var p = e.search.getGeometry().getFirstCoordinate();
  map.getView().animate({
    center: p,
    zoom: 9.7
  });
});

//----------------------------------------------Legend-------------------------
map.addControl(legendCtrl);
//---------------------------------------------------filter----------------------------------

map.addControl(filterPlaces);
map.addControl(filterTravels);
map.addControl(filterChronological);


filterTravels.on('select', function (e) {

  travelsData.getFeatures().forEach(function (f) {
    f.setStyle([]);
  });

  e.features.forEach(function (f) {
    f.setStyle(null);

  });

});

filterPlaces.on('select', function (e) {
  itineraryEntriesData.getFeatures().forEach(function (f) {
    f.setStyle([]);
  });

  e.features.forEach(function (f) {
    f.setStyle(null);

  });

  generateSortedData()

});

filterChronological.on('select', function (e) {

  var minYear = $('.minYear').val()
  var maxYear = $('.maxYear').val()

  if (minYear == 1485 && maxYear == 1548) {
    var minYearDatepicker = DEFAULT_START
    var maxYearDatepicker = DEFAULT_END
  } else if (minYear == 1485 && maxYear != 1548) {
    var minYearDatepicker = DEFAULT_START
    var maxYearDatepicker = $('.maxYear').val() + '-12-31'
  } else if (minYear != 1485 && maxYear == 1548) {
    var minYearDatepicker = $('.minYear').val() + '-01-01'
    var maxYearDatepicker = DEFAULT_END
  } else {
    var minYearDatepicker = $('.minYear').val() + '-01-01'
    var maxYearDatepicker = $('.maxYear').val() + '-12-31'
  }

  setDate(minYearDatepicker, maxYearDatepicker);
  triggerDateChange(minYearDatepicker, maxYearDatepicker);

  chronologicalData.getFeatures().forEach(function (f) {
    f.setStyle([]);
  });
  e.features.forEach(function (f) {
    const dateS = f.get('startDate');
    const dateE = f.get('endDate');
    if (((dateS >= minYear && dateS <= maxYear) || (dateE >= minYear && dateE <= maxYear) || (dateS <= minYear && dateE >= maxYear)) && minYear <= maxYear) {
      f.setStyle(null);
    } else {
      f.setStyle([]);
    }
  });

});

//-----------------------------------------------set values for multiselect---------------------------------

// Set values when loaded
var listenerKey = itineraryEntriesData.on('change', function (e) {
  if (itineraryEntriesData.getState() === 'ready') {
    unByKey(listenerKey);
    // Fill the popup with the features values
    filterPlaces.getControls()[0].setValues({ sort: true });
    filterPlaces.getControls()[1].setValues({ sort: true });
    filterPlaces.getControls()[2].setValues({
      values: {
        '1': '1',
        '2-10': '2-10',
        '11-50': '11-50',
        '51-100': '51-100',
        '>100': '>100'
      },
      sort: false
    });
  }
});

//----------------------------------------------select and filter using checkboxes ----------------------------------------------------

$('#layers_list').on('click', '.form-check-input', function () {
  setTimeout(function () {
    let conditions = createConditions();

    selectPeriod.setConditions({
      usecase: false,
      all: false,
      conditions: conditions,
    });

    selectPeriodTravels.setConditions({
      usecase: false,
      all: false,
      conditions: conditions,
    });

    selectPeriod.doSelect({});
    selectPeriodTravels.doSelect({});
    filterPlaces.doSelect({});
    filterTravels.doSelect({});

  }, 10);
});

//----------------------------------------------print----------------------------------

var printControl = new Print({
  imageType: 'image/png',
  quality: 1
});
map.addControl(printControl);

printControl.on('printing', function (e) {
  $('body').css('opacity', .5);
});
printControl.on(['print', 'error'], function (e) {
  $('body').css('opacity', 1);

  if (e.image) {
    e.canvas.toBlob(function (blob) {
      saveAs(blob, 'map.' + e.imageType.replace('image/', ''));
    }, e.imageType);

  }
});
